import { render, staticRenderFns } from "./ClosedView.vue?vue&type=template&id=ce372406&scoped=true&"
import script from "./ClosedView.vue?vue&type=script&lang=js&"
export * from "./ClosedView.vue?vue&type=script&lang=js&"
import style0 from "./ClosedView.vue?vue&type=style&index=0&id=ce372406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce372406",
  null
  
)

export default component.exports